import { ProductCardSize } from '@croquiscom-pvt/zds';

export function useSizeByThumbnailWidth(thumbnailWidth: number) {
  const size: ProductCardSize = thumbnailWidth >= 113 ? 'medium' : 'small';
  const metadataSize: ProductCardSize = thumbnailWidth >= 100 ? 'medium' : 'small';

  return { size, metadataSize };
}
